import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                close: 'close'
            }
        }
    }

    init() {
        if(!window.localStorage.getItem('centdegres-ressources-visited')) {
            this.el.classList.add('is-active')
        }

        window.localStorage.setItem('centdegres-ressources-visited', true)
    }

    close() {
        this.el.classList.remove('is-active')
        window.localStorage.setItem('centdegres-ressources-visited', true)
    }
}
